"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BtcMethods = exports.SuiMethods = exports.TONMethods = exports.AptosMethods = exports.SOLANAMethods = exports.Eip55Methods = void 0;
exports.hasOKXInjectedProvider = hasOKXInjectedProvider;
function hasOKXInjectedProvider() {
    if (typeof getWindowProviderNamespace("okxwallet") !== 'undefined') {
        return true;
    }
    return false;
}
function getWindowProviderNamespace(namespace) {
    const providerSearch = (provider, namespace) => {
        const [property, ...path] = namespace.split('.');
        const _provider = provider[property];
        if (_provider) {
            if (path.length === 0)
                return _provider;
            return providerSearch(_provider, path.join('.'));
        }
    };
    if (typeof window !== 'undefined')
        return providerSearch(window, namespace);
}
exports.Eip55Methods = [
    "personal_sign",
    "eth_signTypedData_v4",
    "eth_sendTransaction",
    "wallet_addEthereumChain",
    "wallet_watchAsset",
    "wallet_switchEthereumChain",
    "eth_requestAccounts",
    "eth_accounts",
    "eth_chainId"
];
exports.SOLANAMethods = [
    "solana_signTransaction",
    "solana_signMessage",
    "solana_signAllTransactions",
    "solana_signAndSendTransaction"
];
exports.AptosMethods = [
    "aptos_signMessage",
    "aptos_signTransaction",
    "aptos_signAndSubmitTransaction"
];
exports.TONMethods = [
    "ton_sendTransaction",
];
exports.SuiMethods = [
    "sui_signMessage",
    "sui_signPersonalMessage",
    "sui_signTransactionBlock",
    "sui_signAndExecuteTransactionBlock"
];
exports.BtcMethods = [
    "btc_signMessage",
    "btc_signPsbts",
    "btc_send",
    "btc_sendInscription",
    "btc_signAndPushPsbt",
    "btc_inscribeTransfer",
    "btc_sendRunes"
];
